import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CompanyInfoForm = ({ formData, errors, onChange }) => {
  const industryOptions = [
    { value: 'it', label: 'Information Technology' },
    { value: 'finance', label: 'Banking & Finance' },
    { value: 'healthcare', label: 'Healthcare & Pharmaceuticals' },
    { value: 'education', label: 'Education & Training' },
    { value: 'ecommerce', label: 'E-commerce & Retail' },
    { value: 'manufacturing', label: 'Manufacturing & Production' },
    { value: 'consulting', label: 'Consulting & Professional Services' },
    { value: 'marketing', label: 'Marketing & Advertising' },
    { value: 'real-estate', label: 'Real Estate & Construction' },
    { value: 'hospitality', label: 'Hospitality & Tourism' }
  ];

  const companySizeOptions = [
    { value: '1-10', label: '1-10 employees' },
    { value: '11-50', label: '11-50 employees' },
    { value: '51-200', label: '51-200 employees' },
    { value: '201-500', label: '201-500 employees' },
    { value: '501-1000', label: '501-1000 employees' },
    { value: '1000+', label: '1000+ employees' }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Company Name"
          type="text"
          placeholder="Enter your company name"
          value={formData?.companyName}
          onChange={(e) => onChange('companyName', e?.target?.value)}
          error={errors?.companyName}
          required
        />
        <Select
          label="Industry"
          options={industryOptions}
          value={formData?.industry}
          onChange={(value) => onChange('industry', value)}
          error={errors?.industry}
          searchable
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Company Size"
          options={companySizeOptions}
          value={formData?.companySize}
          onChange={(value) => onChange('companySize', value)}
          error={errors?.companySize}
          required
        />
        <Input
          label="Headquarters Location"
          type="text"
          placeholder="e.g., Mumbai, Maharashtra"
          value={formData?.headquarters}
          onChange={(e) => onChange('headquarters', e?.target?.value)}
          error={errors?.headquarters}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Company Website"
          type="url"
          placeholder="https://www.yourcompany.com"
          value={formData?.website}
          onChange={(e) => onChange('website', e?.target?.value)}
          error={errors?.website}
        />
        <Input
          label="Founded Year"
          type="number"
          placeholder="e.g., 2010"
          value={formData?.foundedYear}
          onChange={(e) => onChange('foundedYear', e?.target?.value)}
          error={errors?.foundedYear}
        />
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">
          Company Description <span className="text-destructive">*</span>
        </label>
        <textarea
          className="flex min-h-[150px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          placeholder="Describe your company's mission, vision, values, and what makes it a great place to work..."
          value={formData?.description}
          onChange={(e) => onChange('description', e?.target?.value)}
          rows={6}
        />
        {errors?.description && (
          <p className="text-sm text-destructive mt-1">{errors?.description}</p>
        )}
      </div>
    </div>
  );
};

export default CompanyInfoForm;